import { render, staticRenderFns } from "./cardinality.vue?vue&type=template&id=3063b191&"
import script from "./cardinality.vue?vue&type=script&lang=js&"
export * from "./cardinality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VTextField})
